<template>
  

  <div class="my-3">

    <h5 class="col my-1 text-center">
      <strong>Tabla de Exámenes Auxiliares</strong>
    </h5>

    <b-row>

      <b-col v-if="examenesList.length > 0">
        <b-table 
          :items="examenesList" 
          :fields="tableFields"
          class="text-center"
          responsive small
        >
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>

          <template #cell(descripcion)="data">
            {{ data.item.laboratorio.codigo }} - {{ data.item.laboratorio.descripcion }}
          </template>

          <template #cell(estadoHomologado)="data">
            {{ data.item.estadoHomologado === '1' ? "Si" : "No" }}
          </template>

        </b-table>
      </b-col>
    </b-row>

  </div>
  
</template>

<script>
export default {

  name: "ExamenesListAux",

  props: {
    value: {
      type: Array,
      required: true
    },

    onlyView: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      examenesList: this.value
    }
  },


  methods: {
    removeItem() {}
  },

  computed: {
    tableFields(){
      const baseFields = [
        { 
          key: "index", 
          label: "N°", 
          thClass: "text-center", 
          tdClass: "text-center" 
        },
        { 
          key: "descripcion", 
          label: "codigo - descripcion", 
          thClass: "text-center" 
        },

        {
          key: "estadoHomologado",
          label: "homologado",
        }
        
      ];


      if (this.onlyView) return baseFields;

      return [
        ...baseFields, 
        {
          key     : "acciones",
          label   : "acciones",
          sortable: true,
          thClass : "text-center",
          tdClass : "text-right",
        }
      ];
    }
  }
}
</script>